import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { distinctUntilChanged, filter } from 'rxjs';
import { AuthApiLoggedIn } from './stores/user/user.actions';

@Injectable()
export class AuthInitService {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly store = inject(Store);

  constructor() {
    // HACK: this event will trigger loading of needed data
    // after login. The actuall access-token isn't used anymore.
    this.oidcSecurityService.isAuthenticated$
      .pipe(
        filter((x) => !!x),
        distinctUntilChanged()
      )
      .subscribe(() => {
        this.store.dispatch(new AuthApiLoggedIn({ access_token: 'use_the_oidc_client_instead' }));
      });
  }
}
